module.exports = __webpack_public_path__ + "media/src/assets/img/elements/magic-mouse-3cf7a781374f77d1cf1068a78d3ec9d1.png";